import { Box, Grid, Typography } from "@mui/material";
import RootComponents from "../../components/common/RootComponents";
import styles from "./PostRequirement.module.css";
import { customTextColor, formatDate, formatTime } from "../../utils/const";
import { useState } from "react";
import profile_image from "../../assets/images/ajit_image.jpeg";
import JobList from "../../components/common/JobList";
import { useLocation, useNavigate } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";

const SubmissionDetails = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const { row } = location.state || {};

  const handleExpandClick = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    // <RootComponents>
    <Box className={styles.candidate_structure}>
      <Box className={styles.candidate_listing_text}>
        <Typography sx={{ color: customTextColor }}>
          <b>Posting Requirements</b>
        </Typography>
      </Box>
      <Box className={styles.candidates_details}>
        <Grid container sx={{ alignSelf: "end" }}>
          <Grid
            item
            xs={6}
            sm={6}
            md={3}
            lg={3}
            sx={{
              padding: " 10px ",
            }}
          >
            <span className={styles.profile_card}>
              <Box>
                <Typography sx={{ fontSize: "25px !important" }}>
                  274
                </Typography>
                <Typography>Post Reaching </Typography>
              </Box>
            </span>
          </Grid>
          <Grid item xs={6} sm={6} md={3} lg={3} sx={{ padding: " 10px " }}>
            <span className={styles.profile_card}>
              <Box>
                <Typography sx={{ fontSize: "25px !important" }}>
                  152{" "}
                </Typography>
                <Typography>E-Mail Delivered</Typography>
              </Box>
            </span>
          </Grid>
          <Grid item xs={6} sm={6} md={3} lg={3} sx={{ padding: " 10px" }}>
            <span className={styles.profile_card}>
              <Box>
                <Typography sx={{ fontSize: "25px !important" }}>
                  25{" "}
                </Typography>
                <Typography>Existing Candidate </Typography>
              </Box>
            </span>
          </Grid>
          <Grid item xs={6} sm={6} md={3} lg={3} sx={{ padding: "10px" }}>
            <span className={styles.profile_card}>
              <Box>
                <Typography sx={{ fontSize: "25px !important" }}>
                  127
                </Typography>
                <Typography>Non Existing Candidate </Typography>
              </Box>
            </span>
          </Grid>
          <div
            style={{ marginLeft: "auto", padding: "0 5px" }}
            onClick={handleExpandClick}
          >
            {isExpanded ? <IoIosArrowUp /> : <IoIosArrowDown />}
          </div>
        </Grid>

        {isExpanded && (
          <Box className={styles.profile_and_submit}>
            <Box>
              <Typography sx={{ marginBottom: "10px !important" }}>
                <b>Post Details</b>
              </Typography>
              <Typography>
                Post ID:
                <b> SEC00127</b>
              </Typography>
              <Typography>
                Date:{" "}
                <b>
                  {row?.created_at && formatDate(row?.created_at)}{" "}
                  {row?.created_at && formatTime(row?.created_at)}{" "}
                </b>
              </Typography>
              <Typography sx={{ marginBottom: "0 !important" }}>
                Post Type: <b>Custom </b>
              </Typography>
            </Box>
          </Box>
        )}
      </Box>

      <Grid
        container
        className={styles.profile_details_view}
        sx={{ color: customTextColor, margiTop: "10px" }}
      >
        <Grid
          item
          md={6}
          lg={6}
          sx={{ display: "block !important" }}
          className={styles.profile_details_views}
        >
          <ul
            style={{
              listStyleType: "square",
              padding: "5px 20px",
              marginBottom: "10px",
            }}
          >
            <Box>
              <li>
                <Typography>
                  Job ID: <b>{row?.job_id} </b>
                </Typography>
              </li>
            </Box>
            <Box>
              <li>
                <Typography>
                  Experience: <b>{row?.experience}</b>
                </Typography>
              </li>
            </Box>

            <Box>
              <li>
                <Typography>
                  Mode of Hiring: <b>{row?.job_type}</b>
                </Typography>
              </li>
            </Box>

            <Box>
              <li>
                <Typography>
                  Work Preference:<b> {row?.work_preference}</b>
                </Typography>
              </li>
            </Box>

            <Box sx={{ marginBottom: "0 !important" }}>
              <li>
                <Typography>
                  End Client: <b> Capital One </b>
                </Typography>
              </li>
            </Box>
          </ul>
        </Grid>

        <Grid
          item
          md={6}
          lg={6}
          sx={{ display: "block !important" }}
          className={styles.profile_details_views}
        >
          <ul
            style={{
              listStyleType: "square",
              padding: "5px 20px",
              marginBottom: "10px",
            }}
          >
            <Box>
              <li>
                <Typography>
                  Job Title: <b> {row?.job_title}</b>
                </Typography>
              </li>
            </Box>
            <Box>
              <li>
                <Typography>
                  Location: <b> {row?.location}</b>
                </Typography>
              </li>
            </Box>

            <Box>
              <li>
                <Typography>
                  Work Authorization: <b> {row?.work_authorization}</b>
                </Typography>
              </li>
            </Box>

            <Box>
              <li>
                <Typography>
                  Mode of Interview: <b> {row?.mode_of_interview}</b>
                </Typography>
              </li>
            </Box>
            <Box sx={{ marginBottom: "0 !important" }}>
              <li>
                <Typography>
                  Rate: <b> {row?.rate}</b>
                </Typography>
              </li>
            </Box>
          </ul>
        </Grid>
      </Grid>

      <Box
        className={styles.skill_description}
        sx={{ paddingTop: "0 !important" }}
      >
        <Box
          sx={{ color: customTextColor, padding: "15px 15px 70px !important" }}
        >
          <Typography sx={{ padding: "0 10px 10px 0" }}>
            Job description
          </Typography>
          <span>{row?.job_description}</span>

          <hr></hr>
          <Typography>Mandatory Skills</Typography>
        </Box>
      </Box>

      <Box className={styles.mass_new_structure}>
        <Box className={styles.mass_new_header_text}>
          <Typography>Portal Response</Typography>
        </Box>
        <Box className={styles.requiter_profile_section}>
          {/* {
              row?.shortlisted_candidates?.length !== 0 ?
                row?.shortlisted_candidates?.map((candidate) => {
                  return ( */}
          <JobList
            image={profile_image}
            name="Pratik Chaudhary"
            skill="Lead Java Developer"
            location="Kolkata India"
            status="Green Card"
            btn2="View"
          />
          <JobList
            image={profile_image}
            name=" Ramesh Chaudhary"
            skill=" Lead Java Developer"
            location=" Kolkata India"
            status=" Green Card"
            btn2="Viewed"
          />
          {/* )
                })
                :
                <p style={{ color: customTextColor, textAlign: 'center', padding: '20px', backgroundColor: '#fff' }}>No Respond Found</p>
            } */}
        </Box>
        <Box className={styles.mass_update_btns}>
          <button
            onClick={() =>
              navigate("/post-job-requirement", { state: { row: row } })
            }
          >
            Post Again
          </button>
        </Box>
      </Box>
    </Box>
    // </RootComponents>
  );
};

export default SubmissionDetails;
